import React from "react";
import "./Styles.css";
import {
  FaLinkedin,
  FaTwitter,
  FaGithub,
  FaYoutube,
  FaInstagram,
} from "react-icons/fa";
import logo from "../assets/logo24.png";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <div className="footer-container">
      <div className="footer-inner">
        {/* LEFT BRAND */}
        <div className="footer-brand">
          <div className="footer-logo">
            <img src={logo} alt="logo" />
            <div>
              <h4>Neomonks</h4>
              <p>Tech Pvt Ltd</p>
            </div>
          </div>

          <p className="footer-desc">
            Building AI products that make life simpler, smarter, and more
            meaningful.
          </p>

          <div className="footer-socials">
            <FaLinkedin />
            <FaTwitter />
            <FaInstagram />
            <FaYoutube />
          </div>
        </div>

        {/* COMPANY */}
        <div className="footer-col">
          <h5>COMPANY</h5>
          <Link to="/about-us" className="footer-link">
            About Us
          </Link>
          {/* <a>Careers</a>
          <a>Blog</a> */}
          <Link to="/reach-us" className="footer-link">
            Contact Us
          </Link>
        </div>

        {/* PRODUCTS */}
        <div className="footer-col">
          <h5>PRODUCTS</h5>

          <Link to="/products" className="footer-link">
            All Products
          </Link>

          <Link to="/products" className="footer-link">
            Featured(Gupsy)
          </Link>

            {/* <Link to="/products" className="footer-link">
              For Businesses
            </Link> */}

          <Link to="/products" className="footer-link">
            Upcoming
          </Link>
        </div>

        {/* RESOURCES */}
        {/* <div className="footer-col">
          <h5>RESOURCES</h5>
          <a>Documentation</a>
          <a>Help Center</a>
          <a>Privacy Policy</a>
          <a>Terms of Service</a>
        </div> */}

        {/* CONTACT */}
        <div className="footer-col">
          <h5>CONNECT</h5>

          <Link to="/reach-us" className="footer-link">
            info@neomonkstech.com
          </Link>

          <Link to="/reach-us" className="footer-link">
            +91 99103 57690
          </Link>

          <Link to="/reach-us" className="footer-link">
            Delhi, India
          </Link>
        </div>
      </div>

      {/* BOTTOM */}
      <div className="footer-bottom">
        © {new Date().getFullYear()} Neomonks Tech Pvt Ltd. All rights reserved.
      </div>
    </div>
  );
}
